import { Button, Drawer } from "antd";

import { useTranslation } from "react-i18next";

import styles from "./OtpServiceDrawer.module.css";

export default function OtpServiceDrawer({ open, setOpen, onSelect, options }) {
  const { t } = useTranslation();

  return (
    <Drawer
      maskClassName={styles.servicesMask}
      open={open}
      onClose={() => setOpen(false)}
      placement="bottom"
      height="auto"
      styles={{
        content: {
          borderRadius: "25px 25px 0 0",
        },
        body: {
          paddingTop: 14,
          paddingBottom: 18,
        },
      }}
      closable={false}
    >
      <div className={styles.servicesHeader}>
        <span className={styles.line}></span>
      </div>
      <div className={styles.servicesContainer}>
        {options?.map((service) => (
          <button
            data-testId={service.value}
            key={service.value}
            type="button"
            className={styles.serviceButton}
            onClick={() => {
              onSelect(service);
            }}
          >
            <img
              width={24}
              height={24}
              src={service.icon}
              alt={service.label}
            />
            <div>{t("sendOtp.receive_code", { service: service.label })}</div>
          </button>
        ))}
      </div>
      <Button
        color="default"
        variant="filled"
        size="large"
        style={{
          width: "100%",
          height: 40,
          fontWeight: "bold",
          marginTop: 20,
        }}
        onClick={() => setOpen(false)}
      >
        {t("common.cancel")}
      </Button>
    </Drawer>
  );
}
